<script setup>
defineProps({
  /** sm, md, lg */
  size: { type: String, default: 'md' },
  label: { type: String, default: 'Loading' },
});
</script>

<template>
  <span class="pd-spinner" :class="`pd-spinner--${size}`" role="status">
    <span class="pd-sr">{{ label }}</span>
  </span>
</template>

<style scoped>
.pd-spinner {
  --d: 28px;
  display: inline-block;
  width: var(--d);
  height: var(--d);
  border: 3px solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: pd-spin 700ms linear infinite;
  flex: none;
}
.pd-spinner--sm { --d: 16px; border-width: 2px; }
.pd-spinner--lg { --d: 44px; border-width: 4px; }
@keyframes pd-spin { to { transform: rotate(360deg); } }
</style>
